import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-home-gallery',
  name: '景区环境',
  icon: '景',
  group: '景区主页',
  description: '景区环境横向滚动图集。',
  defaultProps: {
    title: '景区环境',
    imageUrls: []
  }
}
